export default {
  list: {
    method: 'GET',
    url: '/establishments',
  },
  events: {
    method: 'GET',
    url: 'establishments/:id/events',
  },
};
